export const urls = window.sn.urls;
export const enums = window.sn.enums;



// WEBPACK FOOTER //
// ./create_campaign_wizard/constants/global.js